module.exports = __webpack_public_path__ + "static/media/doug-puzzled.42c3bac9.png";